<template>
    <section class="">
        <b-row>
            <b-col cols="12" lg="7">
                <b-form-group :label="'Proveedor'" >
                <Multiselect
                    label="text"
                    :selectLabel="null"
                    track-by="value"
                    :options="suppliersOpts"
                    v-model="selectedSupplier"
                    @select="selectedSupplierAction"
                />
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="5">
                <b-form-group :label="'Fecha'">
                <b-form-datepicker
                    :locale="$root.store.state.currentUser.lang"
                    :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
                    reset-button
                    v-model="date"
                    @input="dateChanged"
                    size="sm"
                />
                </b-form-group>
            </b-col>
            
        </b-row>
        <b-row>
            <b-col cols="12" lg="5">
                <b-form-group :label="'Fecha Fin'">
                <b-form-datepicker
                    :locale="$root.store.state.currentUser.lang"
                    :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
                    reset-button
                    v-model="endDate"
                    :min="date"
                    size="sm"
                />
                </b-form-group>
            </b-col>
            <b-col cols="3" class="d-flex justify-content">
                <b-form-group :label="'.'">
                    <b-button size="sm" @click="search" variant="outline-primary"><md-icon icon="search" ></md-icon></b-button>
                </b-form-group>
            </b-col>
        </b-row>
        <section class="">
            <hr>
            <b-tabs content-class="mt-3" align="center">
                <b-tab active>
                    <template #title> Analisis <md-icon :icon="'pie_chart'"></md-icon> </template>
                    <b-alert variant="info" v-if="$root.isEmpty(selectedSupplier)" show class="text-center">
                        Seleccione un Proveedor para mostrar su operación
                    </b-alert> 
                    <section  v-if="!$root.isEmpty(selectedSupplier) && airportsBySupplierSelected.length>0">
                        <b-row class="text-center d-flex justify-content-center">
                            <!----<h2 class="text-center mb-4">Status Summary</h2>---->
                            <b-col v-for="(airportIata, index) in airportsBySupplierSelected" :key="index" @click="selectAirport(airportIata)"
                                class="status-summary " :class="{ 'selected': selectedAirport.name === airportIata }" cols="12" lg="3">
                                <b-card  text-variant="black" class="mb-2">
                                    <div class="status-summary-item">
                                        <div class="status-color"></div>
                                        <div class="status-details">
                                            <h5>{{ airportIata }} <md-icon :icon="'flight'"></md-icon></h5>
                                        </div>
                                    </div>
                                </b-card>
                            </b-col>
                            
                        </b-row>
                        <b-row>
                            <!-- Right column for displaying rides -->
                            <b-col md="12" class="mt-2">
                                <!----<h2 class="text-center mb-4">Rides</h2>---->
                                <b-card v-if="selectedAirport.name" style="" class="p-2">
                                    <b-overlay :show="selectedAirport.loading" no-wrap></b-overlay>
                                    <h4 class="text-center mt-2" v-if="false">{{ selectedAirport.name }}</h4>
                                    <b-card header="Comparativa asignación" class="text-center"  border-variant="primary">
                                        <h4></h4>
                                        <ChartAverageSuppliersIata :filters="filtersForComparative" :triggerSearch="charts.trigger"></ChartAverageSuppliersIata>
                                    </b-card>
                                    
                                    <b-card header="Reviews" class="text-center mt-2"  border-variant="primary">
                                        <h4 class=""></h4>
                                        <ChartAverageReviewsSuppliersIata :filters="filtersForComparative" :triggerSearch="charts.trigger"></ChartAverageReviewsSuppliersIata>
                                    </b-card>
                                    
                                    <br><hr>
                                    <h4>Data Proveedor: {{ selectedSupplier.name }}</h4>
                                    <b-card header="" class="text-center"  border-variant="primary">
                                        <h4></h4>
                                        <ChartRidesPerSchedule :filters="charts.filters" :triggerSearch="charts.trigger" ></ChartRidesPerSchedule>
                                    </b-card>
                                    
                                    <br><br><hr>
                                    
                                </b-card>
                                <b-card v-else>
                                    <p class="text-center">.</p>
                                </b-card>
                            </b-col>
                        </b-row>
                        
                        
                    </section>
                    <section v-else>No se encontraron Rides</section>
                </b-tab>
                <b-tab  v-if="isOneDay">
                    <template #title> Rides <b v-if="rides.rows.length>0">{{rides.rows.length}}</b> </template>
                    <b-alert variant="info" v-if="$root.isEmpty(selectedSupplier)" show class="text-center">
                        Seleccione un Proveedor para mostrar su operación
                    </b-alert> 
                    <b-alert variant="warning" v-if="!$root.isEmpty(selectedSupplier) && !loading && $root.isEmpty(rides.rows)" show class="text-center">
                        No hay rides asignados al proveedor: <b>{{ selectedSupplier.name }}</b>
                    </b-alert>
                    <section v-if="!$root.isEmpty(selectedSupplier)" class="mb-5"> 
                        <b-card v-for="(ride, index) in rides.rows" :key="index" class="mb-1 p-1 ride-list" :class="{ 'striped': index % 2 !== 0 }" >
                            <b-row>
                                <b-col>
                                    <p class="text-secondary">
                                        <b-badge variant="success" v-if="ride.supplierConfirmation=='confirmed'">{{ ride.supplierConfirmation }}</b-badge>
                                        <b-badge variant="warning" v-else>{{ ride.supplierConfirmation }}</b-badge>
                                        <b-badge 
                                            variant="primary" 
                                            class="ml-1" 
                                            v-b-tooltip.hover title="Tarjeta de Identificación Aeroportuaria"
                                            v-if="hasDriver(ride) && ride.driver.tia == true">
                                            TIA
                                        </b-badge>
                                    </p>
                                </b-col>
                                <b-col>
                                    <p class="text-right mr-3 mb-2 text-primary"><md-icon :icon="tripIcon(ride)"/>
                                        <a href="#" @click="openReservation(ride)" class="text-primary">{{ ride.serviceNumber }}</a>
                                        | <b-badge :variant="getVariantBystatus(ride.status)">{{ride.status}}</b-badge>
                                    </p>
                                </b-col>
                            </b-row>
                            <!-- Driver and Vehicle Info -->
                            <b-row class="mt-2 align-items-center">
                                <b-col class="col-12 col-md-6">
                                    <p class="mb-0">
                                        <b>Driver:</b>
                                        <a href="#" class="text-info">
                                            {{ getDriverFromRide(ride)}}
                                        </a>
                                    </p>
                                </b-col>
                                <b-col class="col-12 col-md-6">
                                    <p class="mb-0">
                                        <b class="text-sm">Unidad:</b> <small>{{ getUnitFromRide(ride) }}</small> 
                                    </p>
                                </b-col>
                            </b-row>
                            <p><b>Client name:</b> {{ ride.reservation.client.firstName }}  {{ ride.reservation.client.lastName }}</p>
                            <p><b>Pickup Date:</b> {{ ride.pickupDatetime }}</p>
                            <p><b>pickup:</b> {{ ride.pickup.name }}</p>
                            <p><b>Dropoff:</b> {{ ride.dropoff.name }}</p>
                            <p><b>h:</b> {{ ride.supplier.name }}</p>
                        </b-card>
                    </section>
                </b-tab>

                
                <b-tab title="Rides selected" v-if="false"><p></p></b-tab>
            </b-tabs>
        </section>
       
        <b-overlay :show="loading" no-wrap></b-overlay>
        <FormReservation
			:model-id="resMod.modelId"
			:copy-from-id="resMod.modelId"
			:formTypeWork="'viewForm'"
			@changeId="resMod.modelId = $event"
			v-model="resMod.show"
		/>
    </section>
</template>
  
  <script>
import moment from 'moment';
import Multiselect from "vue-multiselect";
import FormReservation from "@/components/sections/reservation/formReservation/index";
import ChartRidesPerSchedule from "@/components/sections/dashboard/charts/operations/RidesPerSchedule"
import ChartAverageSuppliersIata from "@/components/sections/dashboard/charts/operations/AveragePerSupplierByAirport.vue"
import ChartAverageReviewsSuppliersIata from "@/components/sections/dashboard/charts/operations/AverageReviewsPerSupplierByAirport.vue"
export default {
    name: 'AssignmentTool',
    components: {Multiselect,FormReservation,ChartRidesPerSchedule,ChartAverageSuppliersIata,ChartAverageReviewsSuppliersIata},
    props: {
		ridesSelected: {
			type: Array,
			required: false
		},
        massiveAssignmenItems:{
			type: Array,
			required: false
		}
	},
    data() {
        return {
            selectedSupplier: null,
            selectedAirport:{ name:"",loading:false},
            loading: false,
            rides:{rows:[]},
            resume:{rows:[]},
            date: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            fields:{
                resume:[
                    { key: 'driver', label: "Conductor"},
                    { key: 'count', label: "Asignados"},
                ]
            },
            activeTab:1,
            resMod:{
                modelId:-1,
                show:false
            },
            charts:{
                trigger:0,
                filters:{
                    dateCriteria:'service-date',
                    startDate:'',
                    endDate:'',
                    groupByCriteria:'per-month',
					supplier:[],
					zones:[],
                }
            },
            iatas:[],
        };
    },
    computed:{
        filtersForComparative(){
            let newFilters =  {...this.charts.filters};
            newFilters.supplier=[];
            return newFilters;
        },
        isOneDay(){
            return (this.endDate===this.date)
        },
        localRidesSelected(){
            if(this.$root.isEmpty(this.ridesSelected)) return [];
            return this.ridesSelected;
        },
        suppliersOpts() {
			let aux = JSON.parse(JSON.stringify(this.$root.auxVars.suppliersOpts));
			return aux;
		},
        airportsBySupplierSelected(){
            return this.iatas;
        }

    },
    methods: {
        hasDriver(ride) {
            if (!this.$root.isEmpty(ride.driver)) return true
            return false;
        },
        getDriverFromRide(ride){
            if(this.$root.isEmpty(ride.driver)) return '--';
            return ride.driver.firstName+" "+ride.driver.lastName
        },
        getUnitFromRide(ride){
            if(this.$root.isEmpty(ride.transportUnit)) return '--';
            return ride.transportUnit.title;
        },  
        tripIcon(rideModel) {
			if (rideModel.pickup.isAirport) return "flight_land";
			//A2H
			else if (rideModel.dropoff.isAirport) return "flight_takeoff";
			//H2A
			else return "place"; //P2P
		},
        openReservation(rideModel){
            this.resMod.modelId = rideModel.reservationId;
            this.resMod.show    = true;
		},
        async dateChanged(){
           this.endDate =this.date;
        },
        async getRides(){
            try{
                let params={
                    filters:{
                        supplier:[this.selectedSupplier.id],
                        pickupStartDate:this.date,
                        pickupEndDate:this.endDate
                    },
                    limit:500,
                    offset:0,
                    sortBy:"pickupDatetime",
                    sortOrder:'ASC'
                }
                const response = await this.$root.api
                .get(`/assignment/tool/transport-services`,{params:params})
                return response.data;
            }catch(error){
                console.error('Error fetching rides:', error);
                return []; // Return an empty array in case of error
            }
        },
        async getIatas(){
            try{
                let params= {
                    supplier:[this.selectedSupplier.id],
                    pickupStartDate:this.date,
                    pickupEndDate:this.endDate
                };
                const response = await this.$root.api
                .post(`/assignment/tool/get/iatas`,params)
                return response.data;
            }catch(error){
                console.error('Error fetching rides:', error);
                return []; // Return an empty array in case of error
            }
        },
        async search(){
            try{
                if(this.$root.isEmpty(this.selectedSupplier)) throw "Supplier is required";
                if(this.$root.isEmpty(this.date)) throw "Date is required";
                if(this.$root.isEmpty(this.endDate))  throw "End date is required";
            }catch(err){
                this.$root.showAlert(err,{variant:'warning'})
                return;
            }
            
            this.loading = true;
            if(this.isOneDay){
                this.rides = await this.getRides();
            }
            this.iatas = await this.getIatas();
            if(!this.$root.isEmpty(this.airportsBySupplierSelected[0])){
                this.selectAirport(this.airportsBySupplierSelected[0])
            }
            this.loading=false;
        },
        getVariantBystatus(status){
			try{
				let variant = this.$root.auxVars.transportServiceStatusOpts.find((el)=>{
					return el.value==status
				});
				if(variant) return variant.class;
			}catch(err){console.log(err)}
			return "info";
		},
        selectedSupplierAction(selected){
            this.selectedSupplier = selected
        },
        showCharts(){
            if(this.$root.isEmpty(this.selectedSupplier)) return;
            if(this.$root.isEmpty(this.date)) return;
            if(this.$root.isEmpty(this.endDate)) return;
            let filters = this.charts.filters;
            try{
                filters.supplier = [this.selectedSupplier.id];
                filters.startDate = this.date;
                filters.endDate   = this.endDate;
            }catch(err){
                console.log(err)
            }
            this.charts.trigger++;
            
        },
        selectAirport(iata){
            this.charts.filters.iata = iata;
            this.selectedAirport.name= iata;
            this.showCharts();
        }
    },
    mounted(){
        this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["suppliersOpts"]
		});
    }
  };
  </script>
<style scoped>
    >>>.card-body{
        padding: 5px !important;
    }
    p{
        margin: 0.5px;
        font-size: smaller;
    }
    .card{
        border-radius: 1.5rem !important;
    }
    >>>label{
        margin-bottom: unset !important;
    }

    .selected .card {
        background-color: blue;
        color: white;
    }
    .status-summary {
        cursor: pointer;
    }
</style>
  